import { handleHttpErrors } from './api';

export const scan = () => {
  return fetch(
    `http://${localStorage.getItem('devconnIP') || 'localhost'}:13385/dev/scan`,
    {
      method: 'GET',
      headers: {},
    },
  ).then(handleHttpErrors);
};
